export default "__VITE_ASSET__e572b190__"